
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trophies",
      function () {
        return require("private-next-pages/trophies/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trophies"])
      });
    }
  